<template>
  <div>
    <vs-prompt
      title="船舶の選択"
      :active.sync="active"
      :is-valid="validateForm"
      :buttonsHidden="true"
      type="confirm"
    >
      <div class="con-exemple-prompt">
        <label>船舶</label>
        <v-select
          placeholder="船舶を選択してください"
          class="style-chooser w-full mb-8"
          :options="vesselInputFormatOptions"
          :clearable="false"
          v-model="selectedVessel"
        />
<!--        <label class="mt-4">操船バージョンのOrigin ID</label>-->
<!--        <vs-input class="mb-8 w-full" v-model="maneuveringOriginId" />-->
<!--        <label lass="mt-4">エンジンバージョンのOrigin ID</label>-->
<!--        <vs-input class="mb-8 w-full" v-model="engineOriginId" />-->
        <a href="#" class="button-a-center">
          <vs-button
            :disabled="validateForm"
            @click="clickConfirm"
            class="mt-4 mb-2"
            color="primary"
            type="filled"
            >確定</vs-button
          >
        </a>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const EnterpriseVesselApi = AiseaApiFactory.get("enterpriseVessel");
import { StoreCommonsMixin } from "@/mixins/addon/secure-dataflow";

export default {
  mixins: [StoreCommonsMixin],
  components: {
    vSelect
  },
  data() {
    return {
      active: false,
      disabled: false,
      vessels: null,
      maneuveringOriginId: 2,
      engineOriginId: 1,
      alertOriginId: 1,
      vesselInputFormatOptions: [],
      selectedVessel: null
    };
  },
  computed: {
    validateForm() {
      return !(
        this.selectedVessel
      );
    }
  },
  methods: {
    show() {
      this.active = true;
    },
    clickConfirm() {
      let payload = {
        vesselInfo: this.vessels[this.selectedVessel.index],
        maneuveringOriginId: this.maneuveringOriginId,
        engineOriginId: this.engineOriginId,
        alertOriginId: this.alertOriginId
      };
      this.setVesselInfoAndVersions(payload);
      this.active = false;
      this.maneuveringOriginId = null;
      this.engineOriginId = null;
      this.alertOriginId = null;
      this.vesselInputFormatOptions = [];
      this.selectedVessel = null;
      this.vessels = null;
      this.setOwnVessels()
    }
  },
  async mounted() {
    let payload = {
      is_disabled: false,
      is_deleted: false,
      page: 0,
      limit: 200
    };
    let res = await EnterpriseVesselApi.search(payload);
    this.vessels = res.data.vessels
    res.data.vessels.forEach((v, i) => {
      this.vesselInputFormatOptions.push({
        label: v.name_ja !== null ? v.name_ja : v.name,
        index: i
      });
    });
    this.selectedVessel = this.vesselInputFormatOptions[0];
  }
};
</script>

<style lang="scss">
.button-form-center {
  text-align: center;
}
.button-a-center {
  text-align: center;
  display: block;
}
</style>
